














































import Vue from "vue";
import { Component, Watch, Emit } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import {
  NoteModel,
  NotesClient
} from "@/diamond-support-api";
import { ErrorMessage, SuccessMessage, SystemMessage } from "@/shared";

@Component
export default class NoteEdit extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;

  shown = true;
  loading = false;

  note: NoteModel = new NoteModel();
  notesApi = new NotesClient();
  search = "";

  async mounted() {
    this.note = await this.notesApi.get(this.$route.params.noteId);
  }

    async save() {
      if (this.$route.params.noteId) {
        this.loading = true;
        await this.notesApi
          .put(this.note)
          .then((response) => {
            if (response !== null) this.emitUpdated(response);
            this.showMessage(new SuccessMessage(`Note has been updated.`));
          })
          .catch((error) => {
            console.log(error);
            this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
          });
      }
      this.shown = false;
    }

  @Emit("itemUpdated")
  emitUpdated(item: NoteModel) {
    return item;
  }

    @Watch("shown")
    onShownChanged() {
      if (!this.shown) {
          this.$router.push(`/associates/${this.$route.params.id}/detail/notesList`);
      }
    }
}
